document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.section-single-industry');
  const MQ = window.matchMedia('(min-width: 768px)');

  // Keep per-section state so we can cleanly destroy
  const state = new WeakMap();

  function initSection(section) {
    if (state.get(section)?.initialized) return;

    const buttons = Array.from(section.querySelectorAll('.tabs__btn'));
    const panels  = Array.from(section.querySelectorAll('.tabs__panel'));
    if (!buttons.length || !panels.length) return;

    // Find initially active index (fallback to 0)
    let current = Math.max(0, buttons.findIndex(b => b.classList.contains('active')));
    if (current === -1) current = 0;

    // Ensure initial visibility (desktop mode = only current visible)
    panels.forEach((p, i) => {
      if (i === current) {
        p.classList.add('active');
        p.removeAttribute('hidden');
        if (window.gsap) gsap.set(p, { autoAlpha: 1 });
      } else {
        p.classList.remove('active');
        p.setAttribute('hidden', '');
        if (window.gsap) gsap.set(p, { autoAlpha: 0 });
      }
    });

    // Handlers
    const handlers = [];
    function focusBtn(i) {
      buttons[i].focus();
      activate(i);
    }
    function activate(next) {
      if (next === current) return;

      const currentPane = panels[current];
      const nextPane    = panels[next];

      buttons.forEach((b, idx) => {
        b.classList.toggle('active', idx === next);
        b.setAttribute('aria-selected', idx === next ? 'true' : 'false');
        b.setAttribute('tabindex',     idx === next ? '0'    : '-1');
      });

      if (window.gsap) {
        gsap.to(currentPane, {
          autoAlpha: 0,
          duration: 0.35,
          onComplete: () => {
            currentPane.classList.remove('active');
            currentPane.setAttribute('hidden', '');

            nextPane.classList.add('active');
            nextPane.removeAttribute('hidden');

            gsap.fromTo(nextPane, { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.35 });
            current = next;
          }
        });
      } else {
        currentPane.classList.remove('active');
        currentPane.setAttribute('hidden', '');
        nextPane.classList.add('active');
        nextPane.removeAttribute('hidden');
        current = next;
      }
    }

    // Attach events
    buttons.forEach((btn, i) => {
      const clickH = () => activate(i);
      const keyH = e => {
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); focusBtn((i + 1) % buttons.length); }
        if (e.key === 'ArrowLeft'  || e.key === 'ArrowUp')   { e.preventDefault(); focusBtn((i - 1 + buttons.length) % buttons.length); }
        if (e.key === 'Home') { e.preventDefault(); focusBtn(0); }
        if (e.key === 'End')  { e.preventDefault(); focusBtn(buttons.length - 1); }
      };
      btn.addEventListener('click', clickH);
      btn.addEventListener('keydown', keyH);
      handlers.push({ btn, clickH, keyH });
    });

    // Set ARIA for desktop mode
    buttons.forEach((b, idx) => {
      b.setAttribute('role', 'tab');
      b.setAttribute('aria-selected', idx === current ? 'true' : 'false');
      b.setAttribute('tabindex', idx === current ? '0' : '-1');
    });
    section.querySelector('[role="tablist"]') || section.setAttribute('role', 'tablist');

    state.set(section, { initialized: true, buttons, panels, handlers });
  }

  function destroySection(section) {
    const s = state.get(section);
    const buttons = Array.from(section.querySelectorAll('.tabs__btn'));
    const panels  = Array.from(section.querySelectorAll('.tabs__panel'));

    // Remove listeners if present
    if (s?.handlers) {
      s.handlers.forEach(({ btn, clickH, keyH }) => {
        btn.removeEventListener('click', clickH);
        btn.removeEventListener('keydown', keyH);
      });
    }

    // Mobile mode: show ALL panels, clear ARIA/active so content is fully visible
    buttons.forEach(b => {
      b.classList.remove('active');
      b.removeAttribute('aria-selected');
      b.removeAttribute('tabindex');
      b.removeAttribute('role');
    });

    panels.forEach(p => {
      p.classList.remove('active');
      p.removeAttribute('hidden');
      if (window.gsap) gsap.set(p, { clearProps: 'opacity,visibility' });
    });

    // Clean state
    state.set(section, { initialized: false });
  }

  function applyMode(matches) {
    sections.forEach(section => {
      if (matches) initSection(section);
      else destroySection(section);
    });
  }

  // Initial apply
  applyMode(MQ.matches);

  // React to screen width changes
  MQ.addEventListener ? MQ.addEventListener('change', e => applyMode(e.matches))
                      : MQ.addListener(e => applyMode(e.matches)); // older Safari fallback
});
